import React from 'react'

interface TrashProps {
  className?: string
}

const Trash: React.FC<TrashProps> = ({ className }: TrashProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.26014 2.54594C2.60296 2.50561 2.91356 2.75082 2.95389 3.09363L4.27422 14.3164C4.43468 15.6804 5.59064 16.7083 6.964 16.7083H11.0357C12.409 16.7083 13.565 15.6804 13.7255 14.3164L15.0458 3.09363C15.0861 2.75082 15.3967 2.50561 15.7395 2.54594C16.0823 2.58627 16.3276 2.89687 16.2872 3.23969L14.9669 14.4625C14.7324 16.456 13.0429 17.9583 11.0357 17.9583H6.964C4.95679 17.9583 3.26731 16.456 3.03278 14.4625L1.71245 3.23969C1.67212 2.89687 1.91733 2.58627 2.26014 2.54594Z"
      fill="#252324"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0415039 3.16666C0.0415039 2.82148 0.321326 2.54166 0.666504 2.54166L17.3332 2.54166C17.6783 2.54166 17.9582 2.82148 17.9582 3.16666C17.9582 3.51184 17.6783 3.79166 17.3332 3.79166L0.666504 3.79166C0.321326 3.79166 0.0415039 3.51184 0.0415039 3.16666Z"
      fill="#252324"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33317 6.70833C7.67835 6.70833 7.95817 6.98815 7.95817 7.33333V12.3333C7.95817 12.6785 7.67835 12.9583 7.33317 12.9583C6.98799 12.9583 6.70817 12.6785 6.70817 12.3333V7.33333C6.70817 6.98815 6.98799 6.70833 7.33317 6.70833Z"
      fill="#252324"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6665 6.70833C11.0117 6.70833 11.2915 6.98815 11.2915 7.33333V12.3333C11.2915 12.6785 11.0117 12.9583 10.6665 12.9583C10.3213 12.9583 10.0415 12.6785 10.0415 12.3333V7.33333C10.0415 6.98815 10.3213 6.70833 10.6665 6.70833Z"
      fill="#252324"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.52704 1.60864C5.83896 0.672854 6.7147 0.0416603 7.7011 0.0416603H10.2986C11.285 0.0416603 12.1607 0.672855 12.4726 1.60864L12.9261 2.96902C13.0353 3.29648 12.8583 3.65043 12.5308 3.75959C12.2033 3.86874 11.8494 3.69177 11.7402 3.3643L11.2868 2.00392C11.145 1.57857 10.7469 1.29166 10.2986 1.29166H7.7011C7.25274 1.29166 6.85468 1.57857 6.71289 2.00392L6.25943 3.3643C6.15028 3.69177 5.79633 3.86874 5.46886 3.75959C5.1414 3.65043 4.96442 3.29648 5.07358 2.96902L5.52704 1.60864Z"
      fill="#252324"
    />
  </svg>
)

export default Trash
